import { createStore } from "vuex";

// 创建一个新的 store 实例
export const store = createStore({
  state() {
    return {
      appInitialized: false, // 添加初始化状态
      // 文章数据
      articlesData: [],
      // 用户信息数据
      userInfoData: [],
      // 是否是登陆状态
      isLoggedIn: false,
      chosenImage: "",
      createAllianceData: {
        teamName: "",
        yourName: "",
        teamUrl: "",
        teamIntroduce: "",
        chosenImage: "",
      },
      // 公告数据
      announcementData0: [],
      announcementData1: [],
      announcementDataAll: [],
      // 攻略数据
      strategyData1: [],
      strategyData2: [],
      strategyData3: [],
      strategyData4: [],
      strategyDataAll: [],
    };
  },
  mutations: {
    setAppInitialized(state, value) {
      state.appInitialized = value;
    },
    setArticlesData(state, data) {
      state.articlesData = data;
    },
    setUserInfoData(state, data) {
      state.userInfoData = data;
    },
    setChosenImage(state, image) {
      state.chosenImage = image;
    },
    updateAllianceData(state, payload) {
      state.createAllianceData = { ...state.createAllianceData, ...payload };
    },
    setLoggedIn(state, loggedIn) {
      state.isLoggedIn = loggedIn;
    },
    setAnnouncementData0(state, data) {
      state.announcementData0 = data;
    },
    setAnnouncementData1(state, data) {
      state.announcementData1 = data;
    },
    setAnnouncementDataAll(state) {
      state.announcementDataAll = [
        ...state.announcementData0,
        ...state.announcementData1,
      ];
    },
    setStrategyData1(state, data) {
      state.strategyData1 = data;
    },
    setStrategyData2(state, data) {
      state.strategyData2 = data;
    },
    setStrategyData3(state, data) {
      state.strategyData3 = data;
    },
    setStrategyData4(state, data) {
      state.strategyData4 = data;
    },
    setStrategyDataAll(state) {
      state.strategyDataAll = [
        ...state.strategyData1,
        ...state.strategyData2,
        ...state.strategyData3,
        ...state.strategyData4,
      ];
    },
  },
  actions: {
    updateArticlesData({ commit }, data) {
      commit("setArticlesData", data);
    },
    updateUserInfoData({ commit }, data) {
      commit("setUserInfoData", data);
    },
    updateChosenImage({ commit }, image) {
      commit("setChosenImage", image);
    },
    // 登陆成功后更新一下这个状态
    updateLoggedIn({ commit }, data) {
      // this.isLoggedIn = loggedIn;
      commit("setLoggedIn", data);
    },
  },
  getters: {
    chosenImage: (state) => state.chosenImage,
    createAllianceData: (state) => state.createAllianceData,
  },
});
